export default "__VITE_ASSET__UHVBOtbm__"